import { useState, useEffect } from "react";
import "./edit-attendance.css";

export default function EditAttendance({ isOpen, onClose, data, onSubmit }) {
    const [isConducted, setIsConducted] = useState(false);
    const [reason, setReason] = useState("");
    const [hasError, setHasError] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (data) {
            setIsConducted(data.conducted ?? false);
            setReason(data.reason || "");
        }
    }, [data]);

    if (!isOpen) return null;

    const handleSubmit = async () => {
        if (!isConducted && !reason) {
            setHasError(true);
            return;
        }
        setHasError(false);
        setLoading(true);
        await onSubmit({ isConducted, reason });
        setLoading(false);
    };

    const handleReasonChange = (e) => {
        setReason(e.target.value);
        if (e.target.value) {
            setHasError(false);
        }
    };

    const isAdd = data?.isAdd;

    return (
        <div className="ea-overlay">
            <div className="ea-modal">
                {/* Header */}
                <div className="ea-header">
                    <h1 className="ea-title">{isAdd ? "Add Attendance" : "Edit Attendance"}</h1>
                    <button className="ea-close-btn" onClick={onClose}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                    </button>
                </div>

                <div className="ea-body">
                    {/* Student Info */}
                    <div className="top-container" >
                        <div className="ea-info-section">
                            <div className="ea-student-name">{data?.title}</div>
                            <div className="ea-class-date">{data?.date}</div>
                            {/* In Add Mode if time isn't set we might want to hide it, but data?.time passes fallback 12:25 */}
                            <div className="ea-class-time">
                                <span className="ea-clock-icon"><img src="clock.svg" /></span>
                                {data?.time}
                            </div>
                        </div>

                        {/* Conducted Toggle */}
                        <div className="ea-conducted-row">
                            <span className="ea-question">Was this class conducted?</span>
                            <div className="ea-toggle-group">
                                <label className="ea-switch">
                                    <input
                                        type="checkbox"
                                        checked={isConducted}
                                        onChange={() => setIsConducted(!isConducted)}
                                    />
                                    <span className="ea-slider"></span>
                                </label>
                                <span className="ea-toggle-status">{isConducted ? "Yes" : "No"}</span>
                            </div>
                        </div>
                    </div>


                    <div className="bottom-container">
                        {/* Reason for not conducted */}
                        {!isConducted && (
                            <div className="ea-reason-section">
                                <label className="ea-reason-label">
                                    Kindly mention the reason why the class was not conducted? <span className="ea-asterisk">*</span>
                                </label>
                                <textarea
                                    className="ea-textarea"
                                    placeholder="Student Cancelled the class"
                                    value={reason}
                                    onChange={handleReasonChange}
                                />
                                {hasError && <p className="ea-error">Please enter a reason for not conducted class.</p>}
                            </div>
                        )}

                        <button className="ea-submit-btn" disabled={loading} onClick={handleSubmit}>
                            {loading ? "Submitting..." : "Submit"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}